import React from 'react';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import {
  ArticleEmailSubscription as ArticleEmailSubscriptionProps,
  SanityKeyed
} from 'types/studio/studio';
import { Typography, Space } from '@ag1/ui';
import styles from './EduArticleEmailSubscription.module.scss';
import EduArticleEmailSubscriptionForm from './EduArticleEmailSubscriptionForm/EduArticleEmailSubscriptionForm';

const EduArticleEmailSubscription = ({
  _type: sectionType,
  label,
  placeholder,
  buttonLabel,
  successMessage,
  errorMessage
}: SanityKeyed<ArticleEmailSubscriptionProps>) => {
  const data = { sectionType, label, placeholder, buttonLabel, successMessage, errorMessage };

  return (
    <Space className={styles.root} top={{ xxs: 32, s: 24 }} bottom={{ xxs: 32, s: 24 }}>
      <div className={styles.wrapper}>
        <Typography
          component="div"
          variant="body"
          size="2"
          weight="700"
          noPadding
          color="black-new"
          className={styles.label}>
          <CustomPortableText value={label} />
        </Typography>
        <EduArticleEmailSubscriptionForm data={data} />
      </div>
    </Space>
  );
};
export default EduArticleEmailSubscription;
